import React, { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

/** Opaque, one-line scope tip — repositioned if it would leave the viewport. */
const ScopeTip = ({ anchorRect, text }) => {
  const tipRef = useRef(null);
  const [pos, setPos] = useState(() => ({
    left: anchorRect.left,
    top: anchorRect.bottom + 6,
  }));

  useLayoutEffect(() => {
    const el = tipRef.current;
    if (!el || !anchorRect) return;
    const pad = 8;
    const w = el.offsetWidth;
    const h = el.offsetHeight;
    let left = anchorRect.left;
    let top = anchorRect.bottom + 6;

    if (left + w > window.innerWidth - pad) {
      left = window.innerWidth - pad - w;
    }
    if (left < pad) left = pad;

    if (top + h > window.innerHeight - pad) {
      top = anchorRect.top - h - 6;
    }
    if (top < pad) top = pad;

    setPos({ left, top });
  }, [anchorRect, text]);

  return createPortal(
    <div
      ref={tipRef}
      className="variables-panel__scope-tip"
      style={{ left: pos.left, top: pos.top }}
      role="tooltip"
    >
      {text}
    </div>,
    document.body
  );
};

export default ScopeTip;
